<template>
  <div class="dropdown-card-container">
    <div class="dropdown-card-header" @click="onHeaderClick()" ref="dropdownHeader">
      <slot name="icon" />
      <span class="header-title">{{ title }}</span>
      <ChevronDown :size="24" />
    </div>

    <div class="dropdown-card-body" ref="collapseBody">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
import ChevronDown from 'icons/ChevronDown'

export default {
  name: 'DropdownCard',
  components: {
    ChevronDown,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  inject: {
    accordion: {
      default: () => ({
        onChildChange: () => { },
      }),
    },
  },
  data() {
    return {
      show: this.value,
    }
  },
  watch: {
    show(show) {
      if (show) {
        this.expand()
      } else {
        this.collapse()
      }
    },
  },
  methods: {
    expand() {
      const bodyContent = this.$refs.collapseBody
      bodyContent.style.height = this.$slots.body[0].elm.clientHeight + 'px'

      const header = this.$refs.dropdownHeader
      header.style.borderRadius = '14px 14px 0 0'

      this.show = true
    },
    collapse() {
      const bodyContent = this.$refs.collapseBody
      bodyContent.style.height = 0

      const header = this.$refs.dropdownHeader
      header.style.borderRadius = '14px 14px 14px 14px'

      this.show = false
    },
    onHeaderClick() {
      this.toggle()
      this.accordion.onChildChange(this, this.show)
    },
    toggle() {
      this.show ? this.collapse() : this.expand()
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown-card-container {
  .dropdown-card-header {
    padding: 1rem 2rem;
    background: #1C2D5A;
    border: 0;
    border-radius: 14px 14px 14px 14px;
    display: flex;
    align-items: center;
    gap: 1rem;
    color: #FFFFFF;
    cursor: pointer;

    .header-title {
      flex: 1;
      font-size: 1.5rem;
      font-weight: 700;
    }

  }

  .dropdown-card-body {
    padding: 0;
    height: 0;
    transition: height 0.3s;
    overflow: hidden;
    background: #FFFFFF;
    border-radius: 0 0 14px 14px;
  }
}
</style>